import { call, all } from 'redux-saga/effects';
import {watchGetDataMain, watchSetDataMain,watchGetDataUser,watchSetDatapermission} from "./mainSaga";
//IndexImportHygen

export default function* rootMenuAuthorizationSaga() {
  yield all([
    //IndexUsingHygen    
    call(watchGetDataMain),
    call(watchSetDataMain),
    call(watchGetDataUser),
    call(watchSetDatapermission)
    
    ])
}